(function () {
  if (typeof window === 'undefined') return;
  var MQ = '(min-width: 990px)';
  var icons = null;
  var originalParent = null;
  var originalNext = null;

  function getIcons() {
    return document.querySelector('.header__icons');
  }

  function moveToUtility() {
    if (!icons) icons = getIcons();
    if (!icons) return;
    var grid = document.querySelector('.utility-bar .utility-bar__grid');
    if (!grid || grid.contains(icons)) return;
    if (!originalParent) {
      originalParent = icons.parentNode;
      originalNext = icons.nextSibling;
    }
    icons.classList.add('utility-bar__icons');
    grid.appendChild(icons);
  }

  function moveBack() {
    if (!icons || !originalParent) return;
    if (originalParent.contains(icons)) return;
    icons.classList.remove('utility-bar__icons');
    originalParent.insertBefore(icons, originalNext);
  }

  function apply() {
    icons = getIcons();
    if (!icons) return;
    // In drawer-menu mode the standard Dawn header layout is used
    // (hamburger | logo | icons). Don't relocate.
    if (document.querySelector('header.header.drawer-menu')) { moveBack(); return; }
    if (window.matchMedia(MQ).matches) moveToUtility();
    else moveBack();
  }

  if (document.readyState !== 'loading') apply();
  else document.addEventListener('DOMContentLoaded', apply);

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(apply, 120);
  });

  document.addEventListener('shopify:section:load', function () { apply(); });
})();
